import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import NumberFormat from "react-number-format";
import dayjs from "dayjs";
import {
  Button,
  Table,
  Spinner,
  Modal,
  Form,
  Row,
  Col,
  ButtonGroup,
  Alert,
} from "react-bootstrap";
import { HiSearchCircle } from "react-icons/hi";

import { ArrowRight, Check, CheckCircle } from "react-bootstrap-icons";
import { useUser, useFirestore, useFunctions } from "reactfire";
import { httpsCallable } from "firebase/functions";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  getDoc,
  addDoc,
  setDoc,
  doc,
  orderBy,
  limit,
  collectionGroup,
  onSnapshot,
} from "firebase/firestore";
import CryptoJS from "crypto-js";
import StockCardSummaryRecon from "../helpers/StockCardSummaryRecon";
import InspectionReport from "../helpers/InpsectionReport";

var relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

const nextYardLocation = "VICInspec";

const ReconVehicleDetailModalArrival = ({
  data,
  show,
  handleClose,
  createNew = false,
  stateFilter,
  buyingFilterUserRoles,
}) => {
  const [loading, setLoading] = useState(false);
  const [localData, setLocalData] = useState(data);

  const [saving, setSaving] = useState(false);
  const [refreshToggle, setRefreshToggle] = useState(false);

  const [hasGPS, setHasGPS] = useState(null);
  const [gpsSerial, setGpsSerial] = useState(null);

  const [existingArrivalForm, setExistingArrivalForm] = useState([]);

  //   Hooks
  const firestore = useFirestore();
  const user = useUser();
  const functions = useFunctions();

  const handleSaveArrivalChecklist = async () => {
    // if > 1 form exists, show confirmation modal
    if (existingArrivalForm.length > 0) {
      const confirm = window.confirm(
        "This vehicle already has an arrival form. Do you want to overwrite it?"
      );
      if (!confirm) {
        toast.error("Form not saved");
        return;
      }
    }
    setSaving(true);

    if (hasGPS === null) {
      toast.error("Please fill in all fields");
      setSaving(false);
      return;
    }

    if (hasGPS === "Yes" && (gpsSerial === "" || gpsSerial === null)) {
      toast.error("Please fill in GPS Serial");
      setSaving(false);
      return;
    }

    console.log(data);
    console.log(user);

    const arrivalChecklistPayload = {
      hasGPS,
      gpsSerial,
      createdBy: user?.data?.displayName,
      createdByEmail: user?.data?.email,
      createdByPhone: user?.data?.phoneNumber,
      createdById: user?.data?.uid,
      createdAt: dayjs().unix(),
      vin: data?.veh?.VEHVIN,
      stockNumber: data?.veh?.VEHStockNumber,
      branchId: data?.veh?.BranchId,
      branchName: data?.veh?.Branch,
      make: data?.veh?.VEHMake,
      model: data?.veh?.VEHmodel,
      year: data?.veh?.VEHModelYear,
      yard: data?.veh?.VEHYard,
      odometer: data?.veh?.VEHOdo,
    };

    console.log(arrivalChecklistPayload);
    // Create an md5 hash of VEHStockNumber and VEHVIN
    const stockVin = `${data?.veh.VEHStockNumber}${data?.veh.VEHVIN}`;
    const hash = CryptoJS.MD5(stockVin).toString();
    console.log(stockVin, hash);

    const arrivalChecklistRef = await addDoc(
      collection(
        firestore,
        "reconditioning-process",
        hash,
        "recon-form-arrival"
      ),
      arrivalChecklistPayload
    )
      .then(async (r) => {
        toast.success("Saved form");
        await pushToNextYardLocation();
        setRefreshToggle((prev) => !prev);
      })
      .catch((e) => {
        toast.error("Error saving form");
        console.log(e);
      });

    setSaving(false);
  };

  const pushToNextYardLocation = async () => {
    setLoading(true);
    const lt = toast.loading("Updating yard location...");
    const yardLocation = nextYardLocation;
    const yardLocationComments = `Changed by ${user.data.displayName} from ${data?.veh?.VEHYard} to ${yardLocation}`;

    const payload = {
      selectedVehicle: data?.veh,
      comments: yardLocationComments,
      createdAt: dayjs().format("YYYY-MM-DD"),
      createdBy: user.data.displayName,
      VEHStockNumber: data?.veh?.VEHStockNumber,
      VIN: data?.veh?.VEHVIN,
      originalBranch: data?.veh?.Branch,
      yardLocation: yardLocation,
      EclipseDBName: data?.veh?.db,
      EclipseBranchID: data?.veh?.BranchId,

      actioned: false,
      actionStatus: null,
      actionedTimestamp: null,
      action: "GENERAL_YARD_LOG_UPDATE",
    };

    // Callable function
    const yardChangeLogRequestD1VIC = httpsCallable(
      functions,
      "yardChangeLogRequestD1VIC"
    );

    await yardChangeLogRequestD1VIC({
      yardChangeData: payload,
      selectedVehicle: data?.veh,
    })
      .then((r) => {
        console.log(r);
        if (r.data.status === "success") {
          toast.success("Yard location update queued");
          toast.success(
            "Yard log should update to Inspection in Eclipse in 5 minutes"
          );
        } else {
          toast.error("Yard location update failed");
        }
      })
      .catch((e) => {
        toast.error(e.message);
      });
    setLoading(false);
    toast.dismiss(lt);
  };

  // On mount load any existing arrival forms
  useEffect(() => {
    const stockVin = `${data?.veh.VEHStockNumber}${data?.veh.VEHVIN}`;
    const hash = CryptoJS.MD5(stockVin).toString();
    console.log(stockVin, hash);
    const arrivalChecklistRef = collection(
      firestore,
      "reconditioning-process",
      hash,
      "recon-form-arrival"
    );
    const q = query(arrivalChecklistRef, orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const arrivalForms = [];
      querySnapshot.forEach((doc) => {
        arrivalForms.push({ id: doc.id, ...doc.data() });
      });
      console.log(arrivalForms);
      setExistingArrivalForm(arrivalForms);
    });
    return () => {
      unsubscribe();
    };
  }, [JSON.stringify(data), refreshToggle]);

  useEffect(() => {
    // Refresh the data when the modal state changes or refreshToggle changes
    setLocalData(data);
    setHasGPS(null);
    setGpsSerial(null);
    setExistingArrivalForm([]);
  }, [show, refreshToggle]);

  return (
    <Modal show={show} size="lg" onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          <h5>
            {data?.veh?.VEHStockNumber} -{" "}
            {`${data?.veh?.VEHModelYear} ${data?.veh?.VEHMake} ${data?.veh?.VEHmodel} ${data?.veh?.Variant}`}
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <h4>Arrival checklist</h4>
            {existingArrivalForm.length > 0 && (
              <div>
                <h5>Existing saved forms</h5>
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>Created At</th>
                      <th>Created By</th>
                      <th>GPS attached</th>
                      <th>GPS Serial #</th>
                      {/* <th>Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {existingArrivalForm.map((form) => {
                      return (
                        <tr key={form.id}>
                          <td>
                            {dayjs
                              .unix(form.createdAt)
                              .format("DD/MM/YYYY HH:mm")}
                          </td>
                          <td>{form.createdBy}</td>
                          <td>{form.hasGPS}</td>
                          <td>{form.gpsSerial}</td>
                          {/* <td>
                            <Button
                              variant="primary"
                              onClick={() => {
                                // setLocalData(form);
                                // setShowArrivalForm(true);
                              }}
                            >
                              View
                            </Button>
                          </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            )}
            <Form>
              <Form.Group controlId="form-service-books-select">
                <Form.Label>Have you attached a GPS Tracker?</Form.Label>
                <Form.Control
                  as="select"
                  name="hasGPS"
                  onChange={(e) => setHasGPS(e.target.value)}
                >
                  <option selected={hasGPS === null}>Not selected</option>
                  <option selected={hasGPS === "No"}>No</option>
                  <option selected={hasGPS === "Yes"}>Yes</option>
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="form-keys-select">
                <Form.Label>GPS Serial</Form.Label>
                <Form.Control
                  as="input"
                  name="gpsSerial"
                  onChange={(e) => setGpsSerial(e.target.value)}
                />
              </Form.Group>
              <InspectionReport vin={data?.veh?.VEHVIN} />
              <ButtonGroup className="mb-2">
                <Button
                  onClick={handleSaveArrivalChecklist}
                  variant="primary"
                  disabled={saving}
                  size="sm"
                >
                  Check in and send to Inspection Lane{" "}
                  {saving && <Spinner size="sm" variant="border" />}
                </Button>
                <Button onClick={handleClose} variant="secondary">
                  Close
                </Button>
              </ButtonGroup>
            </Form>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <StockCardSummaryRecon
          veh={data?.veh}
          yardLogs={data?.veh?.yardLogs || []}
        />
        {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
      </Modal.Footer>
    </Modal>
  );
};

export default ReconVehicleDetailModalArrival;
